import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f32202e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "button-disabled-timer"
}

import { ButtonTypes, ButtonColors, ButtonSizes } from './types';
import Spinner from '@ui-kit/spinner/Spinner.vue';
import { computed, onMounted, onUnmounted, ref } from 'vue';

interface Props {
  label?: string;
  buttonType?: ButtonTypes;
  color?: ButtonColors;
  size?: ButtonSizes;
  disabled?: boolean;
  disableTime?: number;
  loading?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    label: { default: '' },
    buttonType: { default: 'default' },
    color: { default: 'primary' },
    size: { default: 'md' },
    disabled: { type: Boolean, default: false },
    disableTime: null,
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { label: string, buttonType: ButtonTypes, color: ButtonColors, size: ButtonSizes, disabled: boolean, disableTime?: number, loading: boolean }



let disableInterval: number | undefined;
const disabledSeconds = ref(props.disableTime ? Math.ceil(props.disableTime) : 0);

const computedDisabled = computed(() => {
  return props.disabled || disabledSeconds.value > 0;
});

onMounted(() => {
  if (disabledSeconds.value > 0) {
    disableInterval = setInterval(() => {
      disabledSeconds.value -= 1;
      if (disabledSeconds.value <= 0) {
        clearInterval(disableInterval);
        disableInterval = undefined;
      }
    }, 1000);
  }
});
onUnmounted(() => {
  if (disableInterval) {
    clearInterval(disableInterval);
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button", [`color-${__props.color}`, `size-${__props.size}`, `type-${__props.buttonType}`]]),
    disabled: _unref(computedDisabled)
  }, [
    (__props.loading)
      ? (_openBlock(), _createBlock(Spinner, {
          key: 0,
          color: __props.color,
          class: "button-loader",
          size: "sm"
        }, null, 8, ["color"]))
      : _createCommentVNode("", true),
    (!__props.loading && disabledSeconds.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(disabledSeconds.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      style: _normalizeStyle(__props.loading || disabledSeconds.value > 0 ? 'visibility: hidden;' : '')
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(__props.label), 1)
      ])
    ], 4)
  ], 10, _hoisted_1))
}
}

})